import { useEffect } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { pullBandit } from 'src/app/shared/api/bandits';

export function usePullBandits() {
	const {
		data: { bandits },
	} = usePsfPromoteOrSharePageData();
	const utilityContext = useUtilityContext();

	useEffect(() => {
		if (bandits.psfCombo.variant) {
			void pullBandit(
				{ experimentName: bandits.psfCombo.experimentName, variantName: bandits.psfCombo.variant.variantName },
				utilityContext,
				{ silent: true },
			);
		}
		// we only want to do it once per view
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
